import { ConnectionsModalComponentsEnum } from './connections-modal-components.enum';

export interface ConnectionModalState {
	componentName: ConnectionsModalComponentsEnum;
	connectionId: string | null;
}
